/** SK/HU/CZ folding for fuzzy budget matching. Diacritics are stripped, case is ignored. */

const STOP = new Set([
  "a",
  "aj",
  "and",
  "az",
  "cm",
  "do",
  "eur",
  "hr",
  "ks",
  "m2",
  "m3",
  "mm",
  "na",
  "od",
  "pre",
  "so",
  "the",
  "vo",
  "zo"
]);

export function fold(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/ł/g, "l")
    .replace(/ø/g, "o")
    .replace(/đ/g, "d")
    .toLowerCase()
    .replace(/ß/g, "ss");
}

export function cleanSpaces(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

export function roundTo(value: number, digits: number): number {
  const f = 10 ** digits;
  return Math.round((value + Number.EPSILON) * f) / f;
}

/** `1 234,56` / `1.234,56` / `1234.56` → number. */
export function parseLocalizedNumber(raw: string): number | null {
  let s = raw.trim().replace(/[\s\u00a0]/g, "");
  if (!s) return null;
  if (s.includes(",") && s.includes(".")) {
    if (s.lastIndexOf(",") > s.lastIndexOf(".")) s = s.replace(/\./g, "").replace(",", ".");
    else s = s.replace(/,/g, "");
  } else if (s.includes(",")) {
    s = s.replace(",", ".");
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

export function tokenize(folded: string): string[] {
  const spaced = folded.replace(/(\d)(?=[a-z])/gi, "$1 ").replace(/([a-z])(?=\d)/gi, "$1 ");
  return spaced
    .split(/[^a-z0-9]+/i)
    .map((t) => t.toLowerCase())
    .filter((t) => t.length > 0);
}

export function contentTokens(folded: string): string[] {
  return tokenize(folded).filter((t) => (t.length >= 3 || /^\d{2,}$/.test(t)) && !STOP.has(t));
}

export function descriptionKey(description: string): string {
  return fold(cleanSpaces(description)).slice(0, 180);
}
